import { render, staticRenderFns } from "./NavigationItems.vue?vue&type=template&id=246eb450&scoped=true&"
import script from "./NavigationItems.vue?vue&type=script&lang=js&"
export * from "./NavigationItems.vue?vue&type=script&lang=js&"
import style0 from "./NavigationItems.vue?vue&type=style&index=0&id=246eb450&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "246eb450",
  null
  
)

export default component.exports